import phoneUtils from '@exuus/rwanda-phone-utils';

export default ({ phone, password }) => {
  if (phone) {
    if (!phoneUtils(phone).isValid || String(password).length !== 5)
      return false;
    return true;
  }
};
